import { c as _c } from "react/compiler-runtime";
import { getJsxConverters } from '@/features/payload-cms/converters/richtext-lexical';
import type { Locale } from '@/types/types';
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { RichText } from '@payloadcms/richtext-lexical/react';
import type React from 'react';
export interface LexicalRichTextSectionType {
  richTextSection: SerializedEditorState;
}

/**
 * Renders the page content from an editor state.
 *
 * @param richTextSection
 * @param locale - The locale used for resolving internal links.
 * @param converters - Optional custom converters (e.g. for server-side async link resolution).
 */
export const LexicalRichTextSection: React.FC<{
  richTextSection: SerializedEditorState;
  locale?: Locale;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  converters?: Record<string, any>;
}> = t0 => {
  const $ = _c(8);
  const {
    richTextSection,
    locale,
    converters
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = getJsxConverters(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== converters || $[3] !== t1) {
    t2 = {
      ...t1,
      ...converters
    };
    $[2] = converters;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== richTextSection || $[6] !== t2) {
    t3 = <RichText converters={t2} data={richTextSection} />;
    $[5] = richTextSection;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};